import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { DISPUTE_JOB_TYPE } from '@/constants/components/CreateDispute'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import snackMixin from '@/mixins/snackMixin'
import { RootState } from '@/store'
import { isBefore } from '@/utils/date'

export default Vue.extend({
  mixins: [jobPartiesMixin, snackMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    deadline() {
      return this.application.estimatedDeadline
    },
    deadlineHasCome() {
      return isBefore(this.deadline, Date.now())
    },
    hasCreateDispute() {
      return this.isWorker && this.application.job?.stage === STAGE_IN_PROGRESS && this.deadlineHasCome
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    createDispute() {
      if (this.deadlineHasCome) {
        this.openModal({
          component: 'lx-lazy-modal',
          props: {
            factory: import(/* webpackChunkName: "job-modals" */ '@/modals/CreateDispute/CreateDispute.vue'),
            title: 'Open a dispute',
            props: {
              disputeData: {
                type: DISPUTE_JOB_TYPE,
                id: this.application.job.id,
                name: this.application.job.name,
                blockchain: this.application.job.blockchain,
              },
              onSuccess: this.waitRefreshApplication,
            },
          },
        })
      } else {
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: `You can only initiate a dispute once the deadline has been reached.`,
        })
      }
    },
  },
})
